import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["select_business_state", "health_insurance_through_marketplace_select", "tax_prep_receive_1095", "receive_1095_select", "select_state_province", "select_like_receive_refund", "select_like_pay_service", "attend_college_tax_year_2023_select", "tax_prep_receive_1098_college_tuition_statement", "select_filing_status", "tax_prep_spouse_first_name", "tax_prep_spouse_middle_name", "tax_prep_spouse_last_name", "tax_prep_spouse_date_of_birth", "tax_prep_spouse_email", "tax_prep_spouse_ssn", "claiming_children_select", "tax_prep_childs_dependent"]

    initialize() {
        if (this.health_insurance_through_marketplace_selectTarget.value == 'Yes') {
            this.tax_prep_receive_1095Target.classList.add("block");
            this.tax_prep_receive_1095Target.classList.remove("hidden");
        } else {
            this.tax_prep_receive_1095Target.classList.add("hidden");
            this.tax_prep_receive_1095Target.classList.remove("block");
        }

        if (this.attend_college_tax_year_2023_selectTarget.value == 'Yes') {
            this.tax_prep_receive_1098_college_tuition_statementTarget.classList.add("block");
            this.tax_prep_receive_1098_college_tuition_statementTarget.classList.remove("hidden");
        } else {
            this.tax_prep_receive_1098_college_tuition_statementTarget.classList.add("hidden");
            this.tax_prep_receive_1098_college_tuition_statementTarget.classList.remove("block");
        }

        if (this.select_filing_statusTarget.value == 'Married filling jointly' || this.select_filing_statusTarget.value == 'Married filling separate') {
            this.tax_prep_spouse_first_nameTarget.classList.add("block");
            this.tax_prep_spouse_first_nameTarget.classList.remove("hidden");
            this.tax_prep_spouse_middle_nameTarget.classList.add("block");
            this.tax_prep_spouse_middle_nameTarget.classList.remove("hidden");
            this.tax_prep_spouse_last_nameTarget.classList.add("block");
            this.tax_prep_spouse_last_nameTarget.classList.remove("hidden");
            this.tax_prep_spouse_date_of_birthTarget.classList.add("block");
            this.tax_prep_spouse_date_of_birthTarget.classList.remove("hidden");
            this.tax_prep_spouse_emailTarget.classList.add("block");
            this.tax_prep_spouse_emailTarget.classList.remove("hidden");
            this.tax_prep_spouse_ssnTarget.classList.add("block");
            this.tax_prep_spouse_ssnTarget.classList.remove("hidden");
        } else {
            this.tax_prep_spouse_first_nameTarget.classList.add("hidden");
            this.tax_prep_spouse_first_nameTarget.classList.remove("block");
            this.tax_prep_spouse_middle_nameTarget.classList.add("hidden");
            this.tax_prep_spouse_middle_nameTarget.classList.remove("block");
            this.tax_prep_spouse_last_nameTarget.classList.add("hidden");
            this.tax_prep_spouse_last_nameTarget.classList.remove("block");
            this.tax_prep_spouse_date_of_birthTarget.classList.add("hidden");
            this.tax_prep_spouse_date_of_birthTarget.classList.remove("block");
            this.tax_prep_spouse_emailTarget.classList.add("hidden");
            this.tax_prep_spouse_emailTarget.classList.remove("block");
            this.tax_prep_spouse_ssnTarget.classList.add("hidden");
            this.tax_prep_spouse_ssnTarget.classList.remove("block");
        }

        if (this.claiming_children_selectTarget.value == 'Yes') {
            this.tax_prep_childs_dependentTarget.classList.add("block");
            this.tax_prep_childs_dependentTarget.classList.remove("hidden");
        } else {
            this.tax_prep_childs_dependentTarget.classList.add("hidden");
            this.tax_prep_childs_dependentTarget.classList.remove("block");
        }
    }

    select() {
        if (this.select_business_stateTarget.value === '') {
            this.select_business_stateTarget.classList.add("active")
        } else {
            this.select_business_stateTarget.classList.remove('active');
        }

        if (this.select_state_provinceTarget.value === '') {
            this.select_state_provinceTarget.classList.add("active")
        } else {
            this.select_state_provinceTarget.classList.remove('active');
        }

        if (this.select_like_receive_refundTarget.value === '') {
            this.select_like_receive_refundTarget.classList.add("active")
        } else {
            this.select_like_receive_refundTarget.classList.remove('active');
        }
    }

    change() {
        if (this.health_insurance_through_marketplace_selectTarget.value == 'Yes') {
            this.tax_prep_receive_1095Target.classList.add("block");
            this.tax_prep_receive_1095Target.classList.remove("hidden");
        } else {
            this.tax_prep_receive_1095Target.classList.add("hidden");
            this.tax_prep_receive_1095Target.classList.remove("block");
        }

        if (this.attend_college_tax_year_2023_selectTarget.value == 'Yes') {
            this.tax_prep_receive_1098_college_tuition_statementTarget.classList.add("block");
            this.tax_prep_receive_1098_college_tuition_statementTarget.classList.remove("hidden");
        } else {
            this.tax_prep_receive_1098_college_tuition_statementTarget.classList.add("hidden");
            this.tax_prep_receive_1098_college_tuition_statementTarget.classList.remove("block");
        }

        if (this.select_filing_statusTarget.value == 'Married filling jointly' || this.select_filing_statusTarget.value == 'Married filling separate') {
            this.tax_prep_spouse_first_nameTarget.classList.add("block");
            this.tax_prep_spouse_first_nameTarget.classList.remove("hidden");
            this.tax_prep_spouse_middle_nameTarget.classList.add("block");
            this.tax_prep_spouse_middle_nameTarget.classList.remove("hidden");
            this.tax_prep_spouse_last_nameTarget.classList.add("block");
            this.tax_prep_spouse_last_nameTarget.classList.remove("hidden");
            this.tax_prep_spouse_date_of_birthTarget.classList.add("block");
            this.tax_prep_spouse_date_of_birthTarget.classList.remove("hidden");
            this.tax_prep_spouse_emailTarget.classList.add("block");
            this.tax_prep_spouse_emailTarget.classList.remove("hidden");
            this.tax_prep_spouse_ssnTarget.classList.add("block");
            this.tax_prep_spouse_ssnTarget.classList.remove("hidden");
        } else {
            this.tax_prep_spouse_first_nameTarget.classList.add("hidden");
            this.tax_prep_spouse_first_nameTarget.classList.remove("block");
            this.tax_prep_spouse_middle_nameTarget.classList.add("hidden");
            this.tax_prep_spouse_middle_nameTarget.classList.remove("block");
            this.tax_prep_spouse_last_nameTarget.classList.add("hidden");
            this.tax_prep_spouse_last_nameTarget.classList.remove("block");
            this.tax_prep_spouse_date_of_birthTarget.classList.add("hidden");
            this.tax_prep_spouse_date_of_birthTarget.classList.remove("block");
            this.tax_prep_spouse_emailTarget.classList.add("hidden");
            this.tax_prep_spouse_emailTarget.classList.remove("block");
            this.tax_prep_spouse_ssnTarget.classList.add("hidden");
            this.tax_prep_spouse_ssnTarget.classList.remove("block");
        }

        if (this.claiming_children_selectTarget.value == 'Yes') {
            this.tax_prep_childs_dependentTarget.classList.add("block");
            this.tax_prep_childs_dependentTarget.classList.remove("hidden");
        } else {
            this.tax_prep_childs_dependentTarget.classList.add("hidden");
            this.tax_prep_childs_dependentTarget.classList.remove("block");
        }
    }
}
